import styled from "styled-components";
import priceData from "../../data/menu2/naturePoolPricingData.json";
import {device} from "../../assets/styles/media";

const TableWrap = styled.div`
  width: 100%;
    ${device.mobile} {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

    ${device.mobile} {
        min-width: 320px;
    }
`;

const HeadCell = styled.th`
  border: 1px solid #ddd;
  padding: 20px 10px;
  background: #f8f8f8;
  text-align: center;
    font-weight: 700;
    white-space: pre;

    &:first-child {
        width: 250px;
    }

    ${device.tablet} {
        padding: 14px 8px;
        font-size: 15px;

        &:first-child {
            width: 140px;
        }
    }

    ${device.mobile} {
        padding: 10px 0;
        font-size: 12px;

        &:first-child {
            width: 55px;
        }
    }
`;

const SubHeadCell = styled.th`
  border: 1px solid #ddd;
  padding: 16px 10px;
  background: #f8f8f8;
  font-weight: 700;
    ${device.tablet} {
        font-size: 15px;
    }
    ${device.mobile} {
        font-size: 12px;
        padding : 16px 0;
    }
`;

const RowTitle = styled.td`
  border: 1px solid #ddd;
  padding: 16px 10px;
  font-weight: 700;
  text-align: center;
  background: #fafafa;

    ${device.tablet} {
        font-size: 15px;
    }

    ${device.mobile} {
        font-size: 12px;
        word-break: keep-all;
        padding : 16px 0;
    }
`;

const BodyCell = styled.td`
  border: 1px solid #ddd;
  padding: 16px 10px;
  text-align: center;
    white-space: pre-line;

    ${device.tablet} {
        padding: 12px 6px;
        font-size: 14px;
    }

    ${device.mobile} {
        padding: 10px 0;
        font-size: 12px;
    }
`;
const MobileBr = styled.br`
  display: none;
    
    ${device.tablet} {
        display: block;
    }
  ${device.mobile} {
    display: block;
  }
`;

const NewPriceTable = () => {

    const { midSeason, highSeason } = priceData;
    return (
        <TableWrap>
            <Table>
                <thead>
                <tr>
                    <HeadCell>시즌 구분</HeadCell>

                    <HeadCell colSpan={1}>
                        {/*{midSeason.title}*/}
                        <>
                            미드시즌
                            <br />

                                (05/30~07/24,
                                <MobileBr />
                                08/24~09/20)
                        </>
                    </HeadCell>

                    <HeadCell colSpan={2}>
                        {highSeason.title}
                    </HeadCell>
                </tr>

                <tr>
                    <RowTitle>권종</RowTitle>
                    <SubHeadCell>
                        {midSeason.subTitle}
                    </SubHeadCell>

                    {highSeason.tickets.map((ticket) => (
                        <SubHeadCell key={ticket.subTitle}>
                            {ticket.subTitle}
                        </SubHeadCell>
                    ))}
                </tr>
                </thead>

                <tbody>
                {/* 이용시간 */}
                <tr>
                    <RowTitle>이용시간</RowTitle>

                    <BodyCell>
                        {midSeason.time}
                    </BodyCell>

                    {highSeason.tickets.map((ticket) => (
                        <BodyCell key={ticket.subTitle}>
                            {ticket.time}
                        </BodyCell>
                    ))}
                </tr>

                {/* 발권마감 */}
                <tr>
                    <RowTitle>발권 마감시간</RowTitle>

                    <BodyCell>
                        {midSeason.lastTime}
                    </BodyCell>

                    {highSeason.tickets.map((ticket) => (
                        <BodyCell key={ticket.subTitle}>
                            {ticket.lastTime}
                        </BodyCell>
                    ))}
                </tr>

                {/* 가격 */}
                {midSeason.items.map((item, idx) => (
                    <tr key={item.label}>
                        <RowTitle>{item.label}</RowTitle>

                        <BodyCell>
                            {item.price}
                        </BodyCell>

                        {highSeason.tickets.map((ticket) => (
                            <BodyCell key={ticket.subTitle}>
                                {ticket.items[idx].price}
                            </BodyCell>
                        ))}
                    </tr>
                ))}
                </tbody>
            </Table>
        </TableWrap>
    );
};

export default NewPriceTable;